import { urlHostToConfigsMap } from "@/tenants/urlHostToConfigsMap.js"
import store from "../store"

const consoleStyle = "padding: 1px 6px 1px 0px; color: #00be90; font-weight:700;"

function decideHostFromUrl(location) {
	const urlHost = location?.host
	const urlParams = new URLSearchParams(location?.search)

	// Let's say we have URL like this: https://www.some-app.com?hostOverride=some-other-app.com
	// Then we return host based on ?hostOverride: some-other-app.com
	if (urlParams.get?.("hostOverride")) return urlParams.get?.("hostOverride")

	if (localStorage.getItem(process.env.VUE_APP_HOST_KEY)) {
		return localStorage.getItem(process.env.VUE_APP_HOST_KEY)
	}

	// But if we have URL like this: https://www.some-app.com we return: www.some-app.com
	return urlHost
}

function initEnvConfig({ host }) {
	const envConfig = urlHostToConfigsMap[host]?.envConfig
	if (!envConfig) throw new Error("Couldn't load envConfig, did you forget to add envConfig?")

	// Save envConfig into global window so that it is easily accessible e.g. in API fetchers
	window.envConfig = envConfig
}

function initAppConfig({ host }) {
	const appConfig = urlHostToConfigsMap[host]?.appConfig
	if (!appConfig) throw new Error("Couldn't load appConfig, did you forget to add appConfig?")

	// Log into console
	console.group(`%c Cover Studio initialized successfully, yay!`, consoleStyle)
	console.log(`%c host: ${host}`, consoleStyle)
	console.log(`%c tenantId: ${appConfig?.tenantId}`, consoleStyle)
	console.log(`%c appId: ${appConfig?.appId}`, consoleStyle)
	console.log(`%c GraphQL endpoint: ${window.envConfig?.COVERGO_GRAPHQL}`, consoleStyle)
	console.log(`%c Filesystem endpoint: ${window.envConfig?.COVERGO_FILE_SYSTEM}`, consoleStyle)
	console.groupEnd()

	const tenantId = appConfig?.tenantId
	const clientId = appConfig?.appId
	store.commit("updateTenantId", tenantId)
	store.commit("setClientId", clientId)
}

function initFeatureFlags({ host }) {
	const featureFlags = urlHostToConfigsMap[host]?.featureFlags || {}
	window.featureFlags = featureFlags
	store.commit("setFeatureFlags", featureFlags)
}

function clearTokens() {
	localStorage.removeItem(process.env.VUE_APP_TOKEN_KEY)
}

export function initApp(app) {
	const host = decideHostFromUrl(window.location)
	if (!urlHostToConfigsMap[host]) return confirm(`This application doesn't exist.`)

	if (localStorage.getItem(process.env.VUE_APP_HOST_KEY) !== host) clearTokens()

	localStorage.setItem(process.env.VUE_APP_HOST_KEY, host)

	initEnvConfig({ host })
	initAppConfig({ host, app })
	initFeatureFlags({ host })
}
